/** SDCX 方案已接入的 keyboardType 列表（与其它 DK63 型号无关） */
export const SDCX_KEYBOARD_TYPES = ["dk63Machine"] as const;

export type SdcxKeyboardType = (typeof SDCX_KEYBOARD_TYPES)[number];

/** 是否为 SDCX 键盘型号 */
export function isSdcxKeyboardType(
  keyboardType?: string | null
): keyboardType is SdcxKeyboardType {
  return String(keyboardType ?? "") === "dk63Machine";
}

/** 是否支持 Fn 改键层（DK63 Machine 有默认层 + Fn 层，不区分 Win/Mac） */
export function isSdcxFnLayerSupported(keyboardType?: string | null): boolean {
  return isSdcxKeyboardType(keyboardType);
}

/** SDCX 是否支持在线固件升级（首期不支持） */
export function supportsSdcxFirmwareOnlineUpdate(
  _keyboardType?: string | null
): boolean {
  return false;
}

/** 神光同步 / 全局音乐律动：SDCX 首期不支持 */
export function supportsSdcxSyncRgb(_keyboardType?: string | null): boolean {
  return false;
}
